import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './context/AuthContext';
import { AdminProvider } from './context/AdminContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import EnquiryPopup from './components/EnquiryPopup';

// Public pages
import Home from './pages/Home';
import Trips from './pages/Trips';
import TripDetail from './pages/TripDetail';
import About from './pages/About';
import Contact from './pages/Contact';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import PrivateRoute from './components/PrivateRoute';
import ScrollToTop from './components/ScrollToTop';

// Admin pages
import AdminLogin from './admin/AdminLogin';
import AdminGuard from './admin/AdminGuard';
import AdminLayout from './admin/AdminLayout';
import AdminDashboard from './admin/Dashboard';
import AdminTrips from './admin/Trips';
import AdminBookings from './admin/Bookings';
import AdminContacts from './admin/Contacts';
import AdminUsers from './admin/Users';
import AdminMedia from './admin/Media';
import AdminSettings from './admin/Settings';

// Public layout wrapper (with Navbar/Footer/Popup)
function PublicLayout({ children }) {
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <Footer />
      <WhatsAppButton />
      <EnquiryPopup />
    </>
  );
}

// Admin layout wrapper (no public nav/footer)
function AdminWrapper({ children }) {
  return (
    <AdminGuard>
      <AdminProvider>
        <AdminLayout>{children}</AdminLayout>
      </AdminProvider>
    </AdminGuard>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          {/* ── Public routes ── */}
          <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
          <Route path="/trips" element={<PublicLayout><Trips /></PublicLayout>} />
          <Route path="/trips/:id" element={<PublicLayout><TripDetail /></PublicLayout>} />
          <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
          <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
          <Route path="/login" element={<PublicLayout><Login /></PublicLayout>} />
          <Route path="/register" element={<PublicLayout><Register /></PublicLayout>} />
          <Route path="/dashboard" element={<PublicLayout><PrivateRoute><Dashboard /></PrivateRoute></PublicLayout>} />

          {/* ── Admin routes ── */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminWrapper><AdminDashboard /></AdminWrapper>} />
          <Route path="/admin/trips" element={<AdminWrapper><AdminTrips /></AdminWrapper>} />
          <Route path="/admin/bookings" element={<AdminWrapper><AdminBookings /></AdminWrapper>} />
          <Route path="/admin/contacts" element={<AdminWrapper><AdminContacts /></AdminWrapper>} />
          <Route path="/admin/users" element={<AdminWrapper><AdminUsers /></AdminWrapper>} />
          <Route path="/admin/media" element={<AdminWrapper><AdminMedia /></AdminWrapper>} />
          <Route path="/admin/settings" element={<AdminWrapper><AdminSettings /></AdminWrapper>} />
        </Routes>
        <ToastContainer position="bottom-left" autoClose={4000} theme="colored" />
      </Router>
    </AuthProvider>
  );
}

export default App;
